import React from "react";

const HeroSmall = ({ title, sub = false }) => {
  return (
    <div
      className="bg-img-start"
      style={{
        backgroundImage: `url(${
          sub === "market-place" ? "../.." : sub  ? ".." : "."
        }/assets/img/svg/components/sa.svg)`,
      }}
    >
      {/* <div className="bg-img-start" style={{ backgroundImage: "url(./assets/img/svg/components/card-11.svg)" }}> */}
      <div className={`container text-center content-space-3`}>
        <h2
          className={`display-4 text-uppercase text-primary ${
            sub ? "mt-5" : ""
          }`}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* {sub ? (
            <span>
              <img
                src={`${sub ? ".." : "."}/assets/img/svg/_icons/${sub.icon}`}
                width="75"
                height="75"
                alt={sub.name}
                className="me-2"
              />
            </span>
          ) : null} */}

          <span>{title}</span>
        </h2>
      </div>
    </div>
  );
};

export default HeroSmall;
